import { Link } from "react-router-dom";
import { ClipboardCheck, PenLine, TrendingUp, UserCheck, Wrench } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TILES = [
  ["/terreno/asistencia", "Asistencia", "Entrada y salida con el carnet", UserCheck, ["rrhh.asistencia.registrar"], "tile-attendance"],
  ["/terreno/herramientas", "Herramientas", "Entregar y recibir con QR", Wrench, ["abastecimiento.herramientas.entregar", "abastecimiento.devoluciones.recibir"], "tile-tools"],
  ["/terreno/avance", "Avance", "Gantt, bitácora y fotos", TrendingUp, ["operaciones.avance.registrar", "operaciones.bitacora.registrar"], "tile-progress"],
  ["/terreno/firmas", "Firmas", "Charlas con firma de asistentes", PenLine, ["prevencion.charlas.registrar", "prevencion.inducciones.registrar"], "tile-signatures"],
];

export default function Home() {
  const { user, can } = useAuth();
  const tiles = TILES.filter((t) => t[4].some((p) => can(p)));
  return (
    <div data-testid="terreno-home">
      <div className="mb-5"><div className="text-sm text-[#5b6656]">Hola,</div><div className="text-2xl font-extrabold">{user.name.split(" ")[0]}</div></div>
      {tiles.length === 0 ? (
        <div className="rounded-2xl bg-white border border-[#e4e8e1] p-6 text-center text-sm text-[#5b6656]" data-testid="terreno-no-tiles">
          <ClipboardCheck className="mx-auto mb-2 text-[#258F00]" />Su usuario no tiene tareas de terreno asignadas. Puede usar Mensajes y Avisos.
        </div>) : (
        <div className="grid grid-cols-2 gap-3">
          {tiles.map(([to, label, sub, Icon, , testid]) => (
            <Link key={to} to={to} data-testid={testid} className="rounded-3xl bg-white border border-[#e4e8e1] p-5 min-h-[150px] flex flex-col justify-between active:scale-95 transition-transform shadow-sm">
              <div className="h-12 w-12 rounded-2xl bg-[#eef8e6] text-[#258F00] grid place-items-center"><Icon size={26} /></div>
              <div><div className="text-lg font-extrabold leading-tight">{label}</div><div className="text-xs text-[#5b6656]">{sub}</div></div>
            </Link>))}
        </div>)}
    </div>
  );
}
